import Cookies from 'js-cookie'

const TokenKey = 'wmsSupplierToken'
const UserInfoKey = 'wmsSupplierUserInfo'
const NeedChangePwdKey = 'wmsSupplierNeedChangePwd'
const NeedChangePwdOldPwdKey = 'wmsSupplierNeedChangePwdOldPwd'

// cookie:token 操作
export function getToken() {
  return getCookie(TokenKey);
}

export function setToken(token) {
  setCookie(TokenKey, token);
}

export function getCookie(key) {
  return Cookies.get(key);
}

export function setCookie(key, value) {
  return Cookies.set(key, value);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function setUserInfo(userInfo) {
  const value = typeof userInfo === 'string' ? userInfo : JSON.stringify(userInfo || {})
  return setCookie(UserInfoKey, value)
}

export function removeUserInfo() {
  return removeCookie(UserInfoKey)
}

export function removeCookie(key) {
  return Cookies.remove(key);
}

function parseStorageValue(value) {
  if (!value) {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (error) {
    return null
  }
}

export function getNeedChangePwdState() {
  const data = parseStorageValue(localStorage.getItem(NeedChangePwdKey))
  if (!data) {
    return null
  }
  return {
    needChangePwd: Number(data.needChangePwd) === 1 ? 1 : 0,
    needChangePwdReason: data.needChangePwdReason || '',
    needChangePwdAccount: data.needChangePwdAccount || '',
    needChangePwdUserPhone: data.needChangePwdUserPhone || '',
    needChangePwdUserId: data.needChangePwdUserId || ''
  }
}

export function getNeedChangePwdOldPwd() {
  return sessionStorage.getItem(NeedChangePwdOldPwdKey) || ''
}

export function setNeedChangePwdState(state = {}) {
  const data = {
    needChangePwd: Number(state.needChangePwd) === 1 ? 1 : 0,
    needChangePwdReason: state.needChangePwdReason || '',
    needChangePwdAccount: state.needChangePwdAccount || '',
    needChangePwdUserPhone: state.needChangePwdUserPhone || '',
    needChangePwdUserId: state.needChangePwdUserId || ''
  }
  localStorage.setItem(NeedChangePwdKey, JSON.stringify(data))
  if (state.oldPwd) {
    sessionStorage.setItem(NeedChangePwdOldPwdKey, state.oldPwd)
  } else {
    sessionStorage.removeItem(NeedChangePwdOldPwdKey)
  }
  return data
}

export function clearNeedChangePwdState() {
  localStorage.removeItem(NeedChangePwdKey)
  sessionStorage.removeItem(NeedChangePwdOldPwdKey)
}

export function isNeedChangePwdActive() {
  const state = getNeedChangePwdState()
  return !!(state && Number(state.needChangePwd) === 1)
}

export function isLoginPath(path) {
  return !!path && path.indexOf('/login') > -1
}

export function getLoginRedirectPath(alias) {
  return alias ? `/${alias}/login` : '/login'
}
